import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Program History|External Exam|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryExternalExam';
export type SPCandidateHistoryExternalExamLocNames =
	| `${LocNameStart}TitlePageSection`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelUpdated`
	| `${LocNameStart}LabelReviewStatus`
	| `${LocNameStart}LabelInvalid`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelDocumentation`
	| `${LocNameStart}TitleTab`;

export const spCandidateHistoryExternalExamLocs: LocDefs<SPCandidateHistoryExternalExamLocNames> = {
	SPCandidateHistoryExternalExamTitlePageSection: {
		defaultValue: 'External Exams',
		description: 'Page Section Title',
		displayPath: `${pathStart}Page Section Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.Title.PageSectionTitle',
		...sharedProperties,
	},
	SPCandidateHistoryExternalExamLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateHistoryExternalExamLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Column heading for: Active Date.',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPCandidateHistoryExternalExamLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Column heading for: Expire Date.',
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.ColumnHeading.ExpireDate',
		...sharedProperties,
	},
	SPCandidateHistoryExternalExamLabelUpdated: {
		defaultValue: 'Updated',
		description: 'Column heading for: Updated.',
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.ColumnHeading.Updated',
		...sharedProperties,
	},
	SPCandidateHistoryExternalExamLabelReviewStatus: {
		defaultValue: 'Review Status',
		description: 'Column heading for: Review Status.',
		displayPath: `${pathStart}Review Status`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.ColumnHeading.ReviewStatus',
		...sharedProperties,
	},
	SPCandidateHistoryExternalExamLabelInvalid: {
		defaultValue: 'Invalid',
		description: 'Column heading for: Invalid.',
		displayPath: `${pathStart}Invalid`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.ColumnHeading.Invalid',
		...sharedProperties,
	},
	SPCandidateHistoryExternalExamLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: 'Column heading for: Data Provider.',
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.ColumnHeading.DataProvider',
		...sharedProperties,
	},
	SPCandidateHistoryExternalExamLabelDocumentation: {
		defaultValue: 'Documentation',
		description: 'Column heading for: Documentation.',
		displayPath: `${pathStart}Documentation`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.ColumnHeading.Documentation',
		...sharedProperties,
	},
	SPCandidateHistoryExternalExamTitleTab: {
		defaultValue: 'External Credentials',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab title`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.ExternalExams.Title.Tab',
		...sharedProperties,
	},
};

export type SPCandidateHistoryExternalExamLocType = LocMap<SPCandidateHistoryExternalExamLocNames>;
